import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-44cf7b4e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "archive-list"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "归档", -1);
});

var _hoisted_3 = {
  class: "container"
};
var _hoisted_4 = {
  class: "archive-body"
};
var _hoisted_5 = {
  class: "archive-card"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "article-info"
};
var _hoisted_8 = {
  class: "article-meta-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_kila_kila_header = _resolveComponent("kila-kila-header");

  var _component_kila_kila_wife_cover = _resolveComponent("kila-kila-wife-cover");

  var _component_kila_kila_side_bar = _resolveComponent("kila-kila-side-bar");

  var _component_el_timeline_item = _resolveComponent("el-timeline-item");

  var _component_router_link = _resolveComponent("router-link");

  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_el_timeline = _resolveComponent("el-timeline");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _component_kila_kila_footer = _resolveComponent("kila-kila-footer");

  var _component_kila_kila_back_to_top = _resolveComponent("kila-kila-back-to-top");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_kila_kila_header), _createVNode(_component_kila_kila_wife_cover, null, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_kila_kila_side_bar), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_timeline, {
    class: "timeline"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_timeline_item, {
        center: "",
        timestamp: "\u5386\u53F2\u6587\u7AE0 - ".concat($setup.articleCount),
        placement: "top",
        class: "root-item"
      }, null, 8, ["timestamp"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.archives, function (archive) {
        return _openBlock(), _createBlock(_component_el_timeline_item, {
          key: archive.year,
          class: "year-item",
          timestamp: archive.year + '',
          placement: "top"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(archive.articles, function (article) {
              return _openBlock(), _createElementBlock("div", {
                key: article.id,
                class: "article-item"
              }, [_createVNode(_component_router_link, {
                to: "/article/".concat(article.id),
                class: "article-thumbail-link"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    src: article.thumbnail,
                    onErrorOnce: _cache[0] || (_cache[0] = function () {
                      return $setup.useDefaultThumbnail && $setup.useDefaultThumbnail.apply($setup, arguments);
                    }),
                    alt: "缩略图",
                    class: "article-thumbnail"
                  }, null, 40, _hoisted_6)];
                }),
                _: 2
              }, 1032, ["to"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_link, {
                to: "/article/".concat(article.id),
                class: "article-title"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(article.title), 1)];
                }),
                _: 2
              }, 1032, ["to"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'calendar-days'],
                class: "article-meta-data-icon"
              }), _createTextVNode("发表于 " + _toDisplayString(article.createTime), 1)]), _createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'eye'],
                class: "article-meta-data-icon"
              }), _createTextVNode(_toDisplayString(article.viewCount) + "次围观", 1)])])])]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["timestamp"]);
      }), 128))];
    }),
    _: 1
  })]), $setup.articleCount > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    background: "",
    layout: "prev, pager, next",
    total: $setup.articleCount,
    "page-size": $setup.pageSize,
    id: "pagination",
    onCurrentChange: $setup.onCurrentPageChanged
  }, null, 8, ["total", "page-size", "onCurrentChange"])) : _createCommentVNode("", true)])]), _createVNode(_component_kila_kila_footer), _createVNode(_component_kila_kila_back_to_top)]);
}